/* global $ */
import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { config } from '../config.js';

export class BackgroundImageUploadContainer extends Component {
    constructor(props) {
        super(props);

        var adImage = this.props.fieldValues.style;
        if (adImage === "undefined" || adImage === "noimage" || adImage === null || adImage.length === 0 ||
            adImage.indexOf(config.galleryUrl) >= 0) {
            this.props.setBackgroundImagePreviewContainerDisplay("none");
            this.props.setBackgroundImageUploadFormContainer("block");
            this.props.setBackgroundImageUploaded(false);
        } else {
            if (adImage.indexOf('https') >= 0 &&
                adImage.indexOf(config.galleryUrl) === -1) {
                this.props.setBackgroundImagePreviewContainerDisplay("block");
                this.props.setBackgroundImageUploadFormContainer("none");
                this.props.setBackgroundImageUploaded(true);
            }
        }

        this.deleteImagePreview = this.deleteImagePreview.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }

    uploadFile() {
        var fileVal = $("#uploadBackgroundImageForm input:file").val();
        // uploading image
        if (fileVal !== "") {
            if (fileVal.substring(fileVal.lastIndexOf("\\") + 1).length > 45) {
                this.props.showBrandingStateFormError(this.props.showMessage('message_23_07'));
            } else {
                $("#uploadBackgroundImageForm").submit();
            }
        }
    };

    selectFile() {
        $('#uploadBackgroundFile').click();
    }

    deleteImagePreview() {
        var data = {
            style           : ""
        };
        this.props.saveValues(data);

        this.props.setBackgroundImagePreviewContainerDisplay("none");
        this.props.setBackgroundImageUploadFormContainer("block");
        this.props.setBackgroundImageUploaded(false);

        $('#uploadBackgroundFile').val('');
    }

    render() {
        return (
            <div>
                <div id="backgroundImageUploadContainer" style={{display: this.props.showBackgroundUpload}}>
                    <div className="field"
                         id="backgroundImagePreviewContainer"
                         style={{display: this.props.backgroundImagePreviewContainerDisplay}}>
                        <img id="backgroundImagePreviewImg" src={this.props.fieldValues.style} /><br />
                        <Button type="button"
                                className="btn secondary"
                                onClick={this.deleteImagePreview.bind(this)}>{this.props.showMessage('message_23_01')}</Button>
                    </div>
                    <div id="backgroundImageUploadFormContainer"
                         style={{display: this.props.backgroundImageUploadFormContainer}}>
                        <div id="backgroundImageUploadFormOuterContainer">
                            <form id="uploadBackgroundImageForm">
                                <Button type="button" className="btn secondary" onClick={this.selectFile}>{this.props.showMessage('message_23_02')}</Button>
                                <input id="uploadBackgroundFile" type="file" name="uploadedFile" style={{display: 'none'}} onChange={this.uploadFile}/>
                            </form>
                            <ul style={{listStyleType: "none"}}>
                                <li>- {this.props.showMessage('message_23_03')}</li>
                                <li>- {this.props.showMessage('message_23_04')}</li>
                                <li>- {this.props.showMessage('message_23_05')}</li>
                                <li>- {this.props.showMessage('message_23_06')}</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BackgroundImageUploadContainer.jsx